// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#router-view {\n  display: flex;\n  background-color: #00060d;\n}\n#router-view .page-wrapper {\n  display: flex;\n  flex-flow: column;\n  width: 100%;\n  overflow: auto;\n}\n#router-view .page-wrapper .page-header {\n  display: inline-flex;\n  flex: 0 0 auto;\n}\n#router-view .page-wrapper .container {\n  flex: 1 1 100%;\n  overflow-y: auto;\n}", ""]);
// Exports
module.exports = exports;
